import { InjectionToken } from '@angular/core';
import * as mwbscanner from 'cmbsdk-cmbweb';

export const mwbScanner = mwbscanner

export const MWBSCANNER = new InjectionToken<MwbScanner>('MWBSCANNER');

export class MwbScanner {
    getConstants: any
    setIcon: any
    setCallback: any
    loadSettings: any
    startScanning: any
    closeScanner: any
}

export const MwbScannerProvider = {
    provide: MWBSCANNER,
    useFactory: (mwbScanner: MwbScanner) => mwbScanner,
    useValue: mwbScanner,
}